// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import organisationAccreditationEntity from './entities/organisation-accreditation.json';
import organisationAccreditationMenu from '../pages/organisation-accreditation/menu.json';
import organisationAccreditationFullForm from '../pages/organisation-accreditation/forms/full.json';
import organisationAccreditationContextForm from '../pages/organisation-accreditation/forms/context.json';
import organisationAccreditationMiniForm from '../pages/organisation-accreditation/forms/mini.json';
import organisationAccreditationLookupForm from '../pages/organisation-accreditation/forms/lookup.json';
import organisationAccreditationTableView from '../pages/organisation-accreditation/views/table.json';
import organisationAccreditationCardsView from '../pages/organisation-accreditation/views/cards.json';
import organisationAccreditationDashboardView from '../pages/organisation-accreditation/views/dashboard.json';

/** Тип запису «Акредитація» зі сторінками пакета: меню, форми та подання з pages/organisation-accreditation/. */
export const organisationAccreditationDefinition: IRecordTypeDefinition = {
  ...organisationAccreditationEntity,
  views: assembleViewSet({
      table: organisationAccreditationTableView,
      cards: organisationAccreditationCardsView,
      dashboard: organisationAccreditationDashboardView,
  }),
  form: organisationAccreditationFullForm,
  forms: { full: organisationAccreditationFullForm, context: organisationAccreditationContextForm, mini: organisationAccreditationMiniForm, lookup: organisationAccreditationLookupForm },
  menu: organisationAccreditationMenu,
} as IRecordTypeDefinition;
